var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    {
      staticStyle: { width: "100%" },
      attrs: {
        loading: _vm.loading,
        placeholder: _vm.$t("spareNumberPoo.Only10AreDisplayed"),
        clearable: _vm.clearable,
        multiple: _vm.multiple,
        "multiple-limit": _vm.multipleLimit,
        filterable: "",
        remote: _vm.type !== 5,
        "reserve-keyword": _vm.multiple,
        "remote-method": _vm.getProviderPage,
      },
      on: { change: _vm.onChange },
      model: {
        value: _vm.value,
        callback: function ($$v) {
          _vm.value = $$v
        },
        expression: "value",
      },
    },
    _vm._l(_vm.list, function (item) {
      return _c("el-option", {
        key: item.value,
        attrs: { label: item.label, value: item.value },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }